import { QUERY_KEYS } from "@/libraries/constant";
import type {
	GetDeleteMessageBodySchema,
	PatchUpdateMessageBodySchema,
	PostCreateMessageBodySchema,
	PostReadMessagePayloadSchema,
} from "@/schemas";
import type {
	CreateMessageResponse,
	MessageDiscussion,
	ResError,
	UpdateMessageResponse,
} from "@/types";
import { useMutation } from "@tanstack/react-query";

function useMessageMutation() {
	const create = useMutation<
		CreateMessageResponse,
		ResError,
		PostCreateMessageBodySchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_CREATE_MESSAGE],
	});

	const update = useMutation<
		UpdateMessageResponse,
		ResError,
		PatchUpdateMessageBodySchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_UPDATE_MESSAGE],
	});

	const deleteMessage = useMutation<any, ResError, GetDeleteMessageBodySchema>({
		mutationKey: [QUERY_KEYS.MUTATE_DELETE_MESSAGE],
	});

	const readMessage = useMutation<any, ResError, PostReadMessagePayloadSchema>({
		mutationKey: [QUERY_KEYS.MUTATE_READ_MESSAGE],
	});

	const acceptMessage = useMutation<any, ResError, MessageDiscussion>({
		mutationKey: [QUERY_KEYS.MUTATE_MESSAGE_ACCEPT],
	});

	const declineMessage = useMutation<any, ResError, MessageDiscussion>({
		mutationKey: [QUERY_KEYS.MUTATE_MESSAGE_DECLINE],
	});

	return {
		create,
		update,
		deleteMessage,
		readMessage,
		acceptMessage,
		declineMessage,
	};
}

export default useMessageMutation;
